import { create } from 'zustand';
import type { TStage } from '../types';

export type TStageDialogState = { isOpen: boolean; projectId: string; stageIndex: number };

// Gate progress is never saved; it lasts until the page reloads.
type TStore = {
  stagesByProject: Record<string, TStage[]>;
  stageDialogState?: TStageDialogState;
  setStages: (projectId: string, stages: TStage[]) => void;
  setStageDialogState: (state: TStageDialogState) => void;
};

const useProjectStagesStore = create<TStore>((set) => ({
  stagesByProject: {},
  setStages: (projectId, stages) =>
    set((state) => ({ stagesByProject: { ...state.stagesByProject, [projectId]: stages } })),
  setStageDialogState: (stageDialogState) => set({ stageDialogState }),
}));

export default useProjectStagesStore;
